import { render, staticRenderFns } from "./PasswortAendern.vue?vue&type=template&id=1da4a236&scoped=true&"
import script from "./PasswortAendern.vue?vue&type=script&lang=js&"
export * from "./PasswortAendern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4a236",
  null
  
)

export default component.exports